import { setDocFirestore } from '@/services/firebaseWrite'

// Accessing the 'settings' document in the 'settings' collection and getting its data
export const getSettings = async ($fire: any) => {
  return await $fire.firestore.collection('settings').doc('settings').get()
}

// Function to update the settings document in Firestore
export const updateSettings = async ($fire: any, body: any) => {
  return await setDocFirestore($fire, `settings/settings`, { ...body }, true)
}

// Fetching all documents from the 'settings' collection
export const getAllSettings = async ($fire: any) => {
  const settingsDoc = await $fire.firestore
    .collection('settings')
    .doc('settings')
    .get()
  let resp = null
  let version = 1
  if (settingsDoc.data().version) {
    version = settingsDoc.data().version.toMillis() / 1000
  }

  // Determine bundle URL based on environment
  let bundleUrl

  const isLocalhost =
    typeof window !== 'undefined' && window.location.hostname === 'localhost'

  // Check if Firebase is pointing to emulators
  const isUsingEmulator = $fire.firestore._settings?.host?.includes('localhost')

  if (isLocalhost && isUsingEmulator) {
    // Case 1: localhost + emulators
    const projectId = process.env.FB_PROJECT_ID
    bundleUrl = `http://localhost:5001/${projectId}/us-central1/settingsBundle?version=${version}`
  } else if (isLocalhost && !isUsingEmulator) {
    // Case 2: localhost + production Firebase
    const projectId = process.env.FB_PROJECT_ID
    bundleUrl = `https://${projectId}.web.app/settingsBundle?version=${version}`
  } else {
    // Case 3: Production domain -> relative path (CDN)
    bundleUrl = `/settingsBundle?version=${version}`
  }

  try {
    resp = await fetch(bundleUrl)

    if (!resp.ok) {
      throw new Error(`HTTP ${resp.status}`)
    }

    // Load the bundle contents into the Firestore SDK
    await $fire.firestore.loadBundle(resp.body)
  } catch (error) {
    // If bundle loading fails, fallback to direct Firestore query
    console.error('[Settings] Bundle loading failed')
    return await $fire.firestore.collection('settings').get()
  }

  try {
    // Query the results from the cache
    const query = await $fire.firestore.namedQuery('latest-settings-query')
    return await query.get({ source: 'cache' })
  } catch (error) {
    console.error('[Settings] Named query failed')
    return await $fire.firestore.collection('settings').get()
  }
}

export const getAvailableFeatures = async ($fire: any) => {
  try {
    const settingsDoc = await $fire.firestore
      .collection('settings')
      .doc('settings')
      .get()

    const data = settingsDoc.exists ? settingsDoc.data() : {}
    const availableFeatures = data?.availableFeatures ?? {}

    return {
      ...getDefaulFeatures(),
      ...availableFeatures,
    }
  } catch (error) {
    console.error('[Settings] Error fetching available features')
    return getDefaulFeatures()
  }
}

const getDefaulFeatures = () => ({
  credentialManager: false,
})
